import { Controller } from "stimulus";

export default class IndexController extends Controller {
  connect() {
    let raw;
    try {
      raw = window.sessionStorage.getItem("subscriber_v2_threads_origin");
    } catch (e) {
      return;
    }

    if (!raw) return;

    let origin;
    try {
      origin = JSON.parse(raw);
    } catch (e) {
      return;
    }

    if (!origin || !origin.page) return;

    const url = new URL(window.location.href);
    const params = url.searchParams;

    const currentPage = parseInt(params.get("page") || "1", 10);
    const currentSort = params.get("sort") || null;

    const targetPage = origin.page;
    const targetSort = origin.sort || null;
    const targetThreadId = origin.threadId || null;

    // If we're already on the correct page/sort, just scroll to the
    // thread and clear the stored origin.
    if (currentPage === targetPage && currentSort === targetSort) {
      if (targetThreadId) {
        // Wait a frame to ensure Turbo has rendered frames/elements.
        requestAnimationFrame(() => {
          this.scrollToThread(targetThreadId);
        });
      }

      try {
        window.sessionStorage.removeItem("subscriber_v2_threads_origin");
      } catch (e) {}

      return;
    }

    // Navigate to the correct page/sort. We deliberately keep the
    // origin in sessionStorage so that when the new page loads, this
    // controller can run again, see the matching page/sort, and then
    // perform the scroll + clear. The restore flag tells the server
    // to aggregate all pages up to the target page in the initial
    // frame for a smoother scroll-up experience.
    params.set("page", String(targetPage));
    if (targetSort) {
      params.set("sort", targetSort);
    } else {
      params.delete("sort");
    }

    params.set("restore", "1");

    if (targetThreadId) {
      url.hash = `community_thread_${targetThreadId}`;
    } else {
      url.hash = "";
    }

    if (window.Turbo && window.Turbo.visit) {
      window.Turbo.visit(url.toString(), { action: "replace" });
    } else {
      window.location.replace(url.toString());
    }
  }

  scrollToThread(threadId) {
    const el = document.getElementById(`community_thread_${threadId}`);
    if (!el) return;

    el.scrollIntoView({ block: "center" });
  }
}
